(function () {
    'use strict';

    angular
        .module('core')
        .controller('LoginController', LoginController)

    /** @ngInject */
    function LoginController($window, $location, $rootScope, $state, $httpParamSerializerJQLike, AuthenticationService, ApplicationService, ApplicationAuthService, HelperService, sweetAlert, LOCAL_STORAGE_ITEMS) {
        const vm = this;
        let redirectData;
        let isApplicationLogin = false;

        vm.login = () => {
            HelperService.startLoading('.loading-holder');

            const loginData = {
                UserName: vm.loginData.Login,
                Password: Encrypt.Hash(vm.loginData.Password).toString(),
                grant_type: 'password'
            };

            AuthenticationService
                .login(loginData)
                .then(success => {
                    localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN, success.access_token);
                    localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH, success.refresh_token);
                    localStorage.setItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION, moment().add(success.expires_in, 'seconds').format('YYYY-MM-DD HH:mm:ss'));

                    if (isApplicationLogin) {
                        handleUserOauthRedirect(success);
                        return;
                    }

                    $rootScope.hideLoading = false;

                    $state.go('app.home');

                    HelperService.stopLoading('.loading-holder');
                }, error => {
                    HelperService.errorCallback(error);
                    HelperService.stopLoading('.loading-holder');
                });
        }

        init();

        function handleOauthRedirect() {
            redirectData = $location.search();

            $location.search({});

            if (redirectData.ClientId && redirectData.RedirectUrl) {
                HelperService.startLoading('.loading-holder');

                const validateData = {
                    ClientId: redirectData.ClientId,
                    CallbackUrl: redirectData.RedirectUrl
                };

                ApplicationService
                    .validateCallbackUrl(validateData)
                    .then(() => {
                        isApplicationLogin = true;

                        if (AuthenticationService.isLogged()) {
                            const hoursToExpire = moment(localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION)).diff(moment(), 'hours');

                            if (hoursToExpire >= 2) {
                                handleUserOauthRedirect({
                                    access_token: localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN),
                                    refresh_token: localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_REFRESH),
                                    expires_in: moment(localStorage.getItem(LOCAL_STORAGE_ITEMS.ACCESS_TOKEN_EXPIRATION)).diff(moment(), 'seconds')
                                });
                            } else
                                HelperService.stopLoading('.loading-holder');
                        } else
                            HelperService.stopLoading('.loading-holder');
                    }, () => {
                        HelperService.stopLoading('.loading-holder');

                        sweetAlert.swal({
                            title: 'Ação não permitida',
                            text: 'As configurações de retorno não estão entre as permitidas para realizar essa ação',
                            type: 'warning',
                            confirmButtonText: 'Ok',
                            showCancelButton: false,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then(() => {
                            $window.location.reload();
                        });
                    });
            } else {
                handleLoggedUser();
            }
        }

        function handleLoggedUser() {
            if (AuthenticationService.isLogged())
                $state.go('app.home');
        }

        function handleUserOauthRedirect(success) {
            if (ApplicationAuthService.isAuthValid()) {
                ApplicationAuthService.setAuthTry(redirectData.ClientId);

                $window.location.href = `${redirectData.RedirectUrl}?${$httpParamSerializerJQLike(success)}`;

                return;
            } else {
                sweetAlert.swal({
                    title: 'Erro na autenticação!',
                    text: 'A autenticação dessa aplicação está com problemas, entre em contato com nosso suporte.',
                    type: 'warning',
                    confirmButtonText: 'Ok',
                    showCancelButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false
                }).then(() => {
                    handleLoggedUser();
                    ApplicationAuthService.resetAuth();
                    HelperService.stopLoading('.loading-holder');
                });
            }
        }

        function init() {
            handleOauthRedirect();

            $rootScope.authenticationWrapperLarger = false;
        }
    }
}());